var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 30.5535C50 28.5038 49.8298 27.0081 49.4615 25.457H25.5103V34.7082H39.5691C39.2858 37.0072 37.7552 40.4695 34.3537 42.7961L34.306 43.1058L41.879 48.8387L42.4037 48.8899C47.2222 44.5412 50 38.1428 50 30.5535Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5101 54.9289C32.3978 54.9289 38.18 52.7129 42.4035 48.8907L34.3536 42.7969C32.1994 44.2649 29.3082 45.2897 25.5101 45.2897C18.7641 45.2897 13.0386 40.9412 10.9975 34.9307L10.6984 34.9555L2.82393 40.9107L2.72095 41.1904C6.91592 49.3337 15.5327 54.9289 25.5101 54.9289Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9976 34.9303C10.4591 33.3792 10.1474 31.7172 10.1474 30C10.1474 28.2826 10.4591 26.6207 10.9693 25.0697L10.955 24.7393L2.98189 18.6885L2.72102 18.8097C0.992074 22.189 0 25.9837 0 30C0 34.0163 0.992074 37.8108 2.72102 41.1901L10.9976 34.9303Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5101 14.7103C30.3003 14.7103 33.5315 16.7322 35.374 18.422L42.5735 11.5527C38.1519 7.53646 32.3978 5.07129 25.5101 5.07129C15.5327 5.07129 6.91592 10.6663 2.72095 18.8096L10.9692 25.0695C13.0386 19.059 18.7641 14.7103 25.5101 14.7103Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d8bec27b7c3830f1a48c545299b77142.svg";
export { ForwardRef as ReactComponent };